<script setup>
import { onMounted } from 'vue';

const emit = defineEmits(['loaded']);

onMounted(() =>
{
  emit('loaded');
});
</script>

<template>
  <a-alert
    message="Email enviado com sucesso"
    type="success"
    show-icon
  />
</template>
